import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Heart } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { money } from "../lib/api";

export default function ProductCard({ product, index = 0 }) {
  const { wishlist, toggleWish } = useStore();
  const wished = wishlist.includes(product.slug);

  return (
    <motion.article
      whileHover={{ y: -8, transition: { duration: 0.25 } }}
      className="bg-white rounded-cloud shadow-card p-3 flex flex-col h-full border border-candy-soft/50"
      data-testid={`product-card-${product.slug}`}
    >
      <div className="relative rounded-[28px] overflow-hidden bg-gradient-to-br from-candy-soft via-pink-100 to-lilac-soft">
        <Link to={`/product/${product.slug}`} data-testid={`product-image-link-${product.slug}`} aria-label={`View ${product.title}`}>
          <img src={product.image} alt={product.title} loading={index > 2 ? "lazy" : "eager"} className="w-full aspect-[4/4.7] object-cover" />
        </Link>
        {product.badge && (
          <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-butter-accent/90 text-ink text-xs font-extrabold">{product.badge}</span>
        )}
        <button
          data-testid={`wishlist-toggle-${product.slug}`}
          onClick={() => toggleWish(product.slug)}
          aria-label={wished ? `Remove ${product.title} from wishlist` : `Add ${product.title} to wishlist`}
          aria-pressed={wished}
          className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/90 flex items-center justify-center shadow hover:scale-110 transition-transform duration-200"
        >
          <Heart className={`w-4 h-4 ${wished ? "fill-candy" : ""} text-candy`} />
        </button>
      </div>
      <div className="flex flex-col items-center text-center gap-1 pt-4 pb-2 px-2 flex-1">
        <h3 className="font-display font-semibold text-xl text-ink">{product.title}</h3>
        <p className="text-sm text-muted font-semibold" data-testid={`product-price-${product.slug}`}>
          {product.quote_only ? "Ask for price" : money(product.price_cents)}
        </p>
        <Link
          to={`/product/${product.slug}`}
          data-testid={`product-view-${product.slug}`}
          className="mt-3 inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-candy hover:bg-candy-deep text-white font-bold text-sm shadow-pink transition-colors duration-200"
        >
          View item <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </motion.article>
  );
}
